import React from 'react';

import type { VimeoVideoProps } from './vimeo-video-props';

// This component shouldn't be used directly, use instead VimeoPlayer in vimeo-player.txt
const VimeoVideo = ({ src, width, height }: VimeoVideoProps) => (
  <iframe
    src={src}
    width={width}
    height={height}
    frameBorder="0"
    allow="autoplay; fullscreen"
    allowFullScreen
  />
);

export default VimeoVideo;
